__turbopack_context__.v({
  "clearButton": "style-module-scss-module__cyunoq__clearButton",
  "emptyContainer": "style-module-scss-module__cyunoq__emptyContainer",
  "icaoBadge": "style-module-scss-module__cyunoq__icaoBadge",
  "inputWrapper": "style-module-scss-module__cyunoq__inputWrapper",
  "loading": "style-module-scss-module__cyunoq__loading",
  "loadingSkeleton": "style-module-scss-module__cyunoq__loadingSkeleton",
  "loadingSkeletons": "style-module-scss-module__cyunoq__loadingSkeletons",
  "searchInput": "style-module-scss-module__cyunoq__searchInput",
  "searchPanel": "style-module-scss-module__cyunoq__searchPanel",
  "searchResultBoard": "style-module-scss-module__cyunoq__searchResultBoard",
  "searchStationItem": "style-module-scss-module__cyunoq__searchStationItem",
  "searchStationItemsContainer": "style-module-scss-module__cyunoq__searchStationItemsContainer",
  "stationName": "style-module-scss-module__cyunoq__stationName",
  "subTitle": "style-module-scss-module__cyunoq__subTitle",
  "title": "style-module-scss-module__cyunoq__title",
});
